var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('appButton',{attrs:{"button-type":'primary'},nativeOn:{"click":function($event){return _vm.showUploadWidget.apply(null, arguments)}}},[_vm._v(" upload ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }